<template>
	<section class="download">
		<h2 v-if="title">{{ title }}</h2>
		<div v-if="copy" class="copy" v-html="copy"></div>
		<!-- <div class="copy">
			<p>This is some copy that should be here</p>
		</div> -->
		<ul class="files">
			<li v-for="(file, n) in files" :key="`file_${n}`">
				<a
					:href="file.file.url"
					@mouseenter="onPointerMouseEnter($event, 'top')"
					@mouseleave="onPointerMouseLeave($event, 'top')"
				>
					<IconFile :type="file.file.url | filetype" />
					<span>{{ file.file.title }}</span>
					<span>{{ file.file.filesize | size }}</span>
				</a>
			</li>
		</ul>
	</section>
</template>

<script>
import IconFile from "@/components/icons/IconFile";
import pointerHove from "@/mixins/pointerHover";

export default {
	mixins: [pointerHove],
	props: {
		title: String,
		copy: String,
		files: [Boolean, Array],
	},
	components: {
		IconFile,
	},
	filters: {
		size(value) {
			if (!value) return value;

			if (+value > 500000) {
				return Math.round(value * 0.0001) / 100 + " MB";
			}

			return Math.round(value * 0.001) + " KB";
		},
		filetype(value) {
			if (!value) return value;

			return value.split(".").pop();
		},
	},
};
</script>

<style lang="scss" scoped>
.download {
	@include moduleSpacing;
	position: relative;
	width: 100%;

	h2 {
		@include fontH1;
		letter-spacing: -1px;
		// margin-bottom: 20px;

		@include mq($from: m) {
			// margin-bottom: 40px;
			@include gridColumn(m, 22, 1, false, true);
		}

		@include mq($from: xl) {
			@include gridColumn(m, 20, 2, false, true);
		}
	}

	.copy {
		margin-top: 10px;

		@include mq($from: m) {
			margin-top: 20px;
		}
	}

	.files,
	.copy {
		@include fontCopy;
		@include textFormat;
		width: 100%;

		@include mq($from: m) {
			@include gridColumn(m, 12, 1, false, true);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 12, 2, false, true);
		}

		&::v-deep * {
			@include fontCopy;
		}
	}

	.files {
		display: flex;
		flex-wrap: wrap;
		list-style: none;
		// margin-top: 40px;
		transform: translate(-30px);
		width: 100%;

		@include mq($from: xl) {
			width: 50%;
		}

		li {
			padding: 30px;
			flex: 0 0 50%;

			@include mq($from: m) {
				flex: 0 0 25%;
			}

			a {
				text-decoration: none;
				text-align: center;
				display: block;

				&::v-deep svg path {
					transition: fill 0.3s;
				}

				&:hover {
					&::v-deep svg path {
						fill: $colorGraphite !important;
					}
				}
			}

			span {
				@include fontCopyS;
				font-weight: 400;
				display: block;
			}
		}
	}
}
</style>
